// extracted by mini-css-extract-plugin
module.exports = {"subscriptionVoucherWarnModal":"d4","header":"d5","body":"d6","buttonRow":"d7","buttonWrapper":"d8","button":"d9","error":"d-"};